import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, unref as _unref } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "py-1" }
const _hoisted_3 = { class: "py-1" }
const _hoisted_4 = { class: "py-1" }
const _hoisted_5 = { class: "py-1" }
const _hoisted_6 = { class: "py-1" }
const _hoisted_7 = { key: 2 }

import { computed, PropType } from 'vue';
import { useStore } from 'vuex';
import Copy from '@/components/micro/CopyComponent.vue';
import Duration from '@/components/micro/DurationComponent.vue';
import RawRecords from '@/components/micro/RawRecords.vue';
import CnameChainBadge from '@/components/micro/CnameChainBadge.vue';
import { getRecordType } from '@/common/recordTypes';
import { QueryResult, RecordInfo, TLSA } from '@/model/Api';

type TlsaRecordWithInfo = {
  record: TLSA;
} & RecordInfo


export default /*@__PURE__*/_defineComponent({
  __name: 'TlsaRecords',
  props: {
  records: {
    type: Object as PropType<QueryResult>,
    required: true,
  },
  domain: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const recordType = getRecordType('TLSA');

const store = useStore();
const showRawOutput = computed(() => store.state.showRawOutput);

const processedRecords = computed(() => {
  const processed: TlsaRecordWithInfo[] = props.records.response.answer.filter((item): item is TlsaRecordWithInfo => item.record.recordType === recordType.upper);
  return processed;
});

return (_ctx: any,_cache: any) => {
  return (showRawOutput.value)
    ? (_openBlock(), _createBlock(RawRecords, {
        key: 0,
        records: __props.records
      }, null, 8, ["records"]))
    : (processedRecords.value.length !== 0)
      ? (_openBlock(), _createElementBlock("table", _hoisted_1, [
          _cache[0] || (_cache[0] = _createElementVNode("colgroup", null, [
            _createElementVNode("col", { style: {"width":"15%"} }),
            _createElementVNode("col", { style: {"width":"10%"} }),
            _createElementVNode("col", { style: {"width":"15%"} }),
            _createElementVNode("col", { style: {"width":"45%"} }),
            _createElementVNode("col", { style: {"width":"15%"} })
          ], -1)),
          _cache[1] || (_cache[1] = _createElementVNode("thead", null, [
            _createElementVNode("tr", { class: "border-b-2 border-gray-200 text-left" }, [
              _createElementVNode("th", {
                scope: "col",
                class: "py-1.5 font-medium"
              }, "Certificate usage"),
              _createElementVNode("th", {
                scope: "col",
                class: "py-1.5 font-medium"
              }, "Selector"),
              _createElementVNode("th", {
                scope: "col",
                class: "py-1.5 font-medium"
              }, "Matching type"),
              _createElementVNode("th", {
                scope: "col",
                class: "py-1.5 font-medium"
              }, "Certificate association data"),
              _createElementVNode("th", {
                scope: "col",
                class: "py-1.5 font-medium"
              }, "Revalidate in")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(processedRecords.value, (record, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: index,
                class: "group"
              }, [
                _createElementVNode("td", _hoisted_2, [
                  _createElementVNode("span", null, _toDisplayString(record.record.certificateUsage), 1)
                ]),
                _createElementVNode("td", _hoisted_3, [
                  _createElementVNode("span", null, _toDisplayString(record.record.selector), 1)
                ]),
                _createElementVNode("td", _hoisted_4, [
                  _createElementVNode("span", null, _toDisplayString(record.record.matchingType), 1)
                ]),
                _createElementVNode("td", _hoisted_5, [
                  _createElementVNode("span", null, _toDisplayString(record.record.certificateAssociationData), 1),
                  _createVNode(CnameChainBadge, {
                    chain: record.cnameChain
                  }, null, 8, ["chain"]),
                  _createVNode(Copy, {
                    content: record.record.certificateAssociationData,
                    class: "[visibility:hidden] group-hover:visible"
                  }, null, 8, ["content"])
                ]),
                _createElementVNode("td", _hoisted_6, [
                  _createVNode(Duration, {
                    seconds: record.record.ttl
                  }, null, 8, ["seconds"])
                ])
              ]))
            }), 128))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, "No " + _toDisplayString(_unref(recordType).plural) + " found.", 1))
}
}

})